/**
 * Snowboard Addiction — Product URL cleanup for geolocation / ad landings
 * Source: snippets/product-form.liquid ~399–420 (Story v3.1 export, known-good)
 *
 * Strips query string (variant, utm_*, gclid, srsltid, country) after Shopify.country is available.
 * Intended to work with Selecty / localization apps.
 */
document.addEventListener('DOMContentLoaded', function () {
  function cleanUrlOnceSafe() {
    if (typeof Shopify === 'undefined' || !Shopify.country) {
      return setTimeout(cleanUrlOnceSafe, 100);
    }

    const url = new URL(window.location.href);
    const isDirty =
      url.searchParams.has('variant') ||
      Array.from(url.searchParams.keys()).some(
        (key) =>
          key.startsWith('utm') ||
          key === 'gclid' ||
          key === 'srsltid' ||
          key === 'country'
      );

    if (isDirty) {
      window.history.replaceState({}, document.title, url.pathname);
    }
  }

  cleanUrlOnceSafe();
});
